import { UserManager } from 'oidc-client';

/**
 * The UserManager constructor requires a settings object as a parameter.
 * It accepts a config object with properties.
 */

const createUserManager = (config) => {
  const userManager = new UserManager(config);
  return userManager;
};

export default createUserManager;
